import type { PatientAlternativeAddressType } from '@common/validation/customControls/patientContactDetailsSchema';
import {
    type DiagnosisData,
    type HolterAnamnesisData,
    type HolterEcgData,
    type HolterExaminationRequestAdvice,
    type HolterReferralData,
    type HolterRiskFactorsData,
    type RelevanteVoorgeschiedenis,
} from '@common/validation/customControls/cardiology/holter/utils/utils';

export const holterExaminationRequestReferralInitialData: HolterReferralData = {
    generalPractitioner: {
        organizationId: null,
        practitionerId: null,
    },
};

export const holterExaminationRequestPatientAlternativeAddressInitialData: PatientAlternativeAddressType = {
    alternativeAddress: {
        city: null,
        houseLetter: null,
        houseNumber: null,
        houseNumberSuffix: null,
        street: null,
        zip: null,
    },
    sendToAlternativeAddress: false,
};

export const holterAnamnesisSectionInitialData: HolterAnamnesisData = {
    hasPacemaker: false,
    reden_holter_event: {
        algemene_onderzoek: false,
        anders: null,
        collapsneiging: false,
        duizeligheid: false,
        dysponea: false,
        geruststelling: false,
        hartkloppingen_overslagen: false,
        klachten: false,
        moeheid: false,
        onregelmatige_pols: false,
        pijn_op_de_borst: false,
        wegraking: false,
    },
};

export const holterEcgSectionInitialData: HolterEcgData = {
    ecg: null,
    ecg_afwijkingen: null,
    ecg_afwijkingen_opmerkingen: null,
};

export const holterVoorgeschiedenisSectionInitialData: RelevanteVoorgeschiedenis = {
    anders: null,
    boezemfibrilleren: false,
    copd: false,
    diabetes: false,
    extrasystoly: false,
    geleidingstoornis: false,
    hartfalen: false,
    hypertensie: false,
    kleplijden: false,
    myocardinfarct: false,
    slaapapneu: false,
    super_verticulaire_tachycardie: null,
    tia_cva: false,
    ventriculaire_tachycardie: null,
};

export const dignosisInitialData: DiagnosisData = {
    diagnosis_icd10: null,
    hasDiagnosis: null,
};

export const generalRiskFactorsInitialData = {
    adiposity: false,
    alcohol: false,
    cardiovascular_disease: false,
    diabetes_mellitus: false,
    drugs: false,
    dyslipidemia: false,
    hypertension: false,
    migraines: false,
    rheumatic_disease: false,
    smoking: false,
    thyroid_dysfunction: false,
};

export const familialRiskFactorsInitialData = {
    cardiomyopathy: false,
    heart_valve_disease: false,
    myocardinfarct: false,
    pacemaker_implementation: false,
    pci_cabg: false,
    sudden_cardiac_death: false,
    unknown: false,
};

export const femaleRiskFactorsInitialData = {
    hypertension_before_menopause: false,
    hypertension_during_pregnancy: false,
    menopause: false,
    miscarriage: false,
};

export const holterRiskFactorsSectionInitialData: HolterRiskFactorsData = {
    familial_riskfactors: { ...familialRiskFactorsInitialData },
    female_riskfactors: { ...femaleRiskFactorsInitialData },
    general_riskfactors: { ...generalRiskFactorsInitialData },
    riskfactors_remark: null,
};

export const holterAdviceInitialData: HolterExaminationRequestAdvice = {
    ...holterRiskFactorsSectionInitialData,
    ...dignosisInitialData,
    meedenkadvies_cardioloog: null,
    vraag_aan_specialist: null,
};
